import { FC, useEffect, useState } from 'react';
import { FlexGrid } from '../../../../components/FlexGrid';
import { getListProviderQueryParams } from '../../context/ListProvider/utils';
import { useListFilterBreadcrumbCollapseProvider } from './ListFilterBreadcrumbCollapseProvider';
import { ListFilterBreadcrumbTempItem } from './ListFilterBreadcrumbTempItem';
import { skipFilterValueKeys, skipFilterValues } from './const';
import classes from './styles/index.module.scss';

function getFilledTempArray(count) {
	return Array.from(Array(count).keys());
}

export const ListFilterBreadcrumbTemp: FC = () => {
	const [tempItems, setTempItems] = useState<Array<number>>([]);
	const { visibleItemsCount } = useListFilterBreadcrumbCollapseProvider();

	useEffect(() => {
		const urlParams = getListProviderQueryParams();
		const urlKeys = Object.keys(urlParams).map((i) => String(i).toLowerCase());

		if (urlKeys.length === 1 && String(urlKeys[0]).toLowerCase() === 'savedfilter') {
			setTempItems(getFilledTempArray(3));

			return;
		}

		const filterKeysCount: number = urlKeys
			.filter((i) => {
				const filterValue = urlParams[i];
				const normalizedKey = String(i).toLowerCase();

				if (skipFilterValueKeys.includes(normalizedKey)) {
					return false;
				}

				if (typeof filterValue === 'string') {
					return !skipFilterValues.includes(filterValue.toLowerCase());
				}

				return true;
			}, 0)
			.reduce<number>((count, i) => {
				const filterValue = urlParams[i];
				const currentCount = Array.isArray(filterValue) ? filterValue.length : 1;

				return currentCount + count;
			}, 0);

		setTempItems(getFilledTempArray(filterKeysCount));
	}, []);

	if (tempItems.length === 0) {
		return null;
	}

	return (
		<FlexGrid
			gap='tiny'
			wrap
			className={classes.listPageFilterBreadcrumbs}
		>
			{tempItems.slice(0, visibleItemsCount).map((i) => (
				<ListFilterBreadcrumbTempItem key={i} />
			))}
		</FlexGrid>
	);
};
